import { colors } from "../../../constant/constants";
import { labelContacts } from "../../../constant/labels";

export default {
    dashboardOverviewBegin(state) {
        state.loadingOverview = true;
    },

    dashboardOverviewSuccess(state, data) {
        state.loadingOverview = false;
        state.data = data;
    },

    dashboardOverviewErr(state, err) {
        state.loadingOverview = false;
        state.error = err;
    },

    dashboardLabelBegin(state) {
        state.loadingLabels = true;
    },

    dashboardLabelSuccess(state, data) {
        state.labelsDonut = [];
        if (data.length > 0) {
            data.forEach(label => {
                // El catalogo fijo solo cubre los ids 1..9. Las etapas ahora se
                // configuran por cliente, asi que un id de fuera es posible: sin
                // esta comprobacion, find() devuelve undefined y leer .color
                // tumba el grafico entero del Panel.
                const enCatalogo = labelContacts.find(l => l.id === label.labelId);
                const color = (enCatalogo && enCatalogo.color) || colors.primary;
                state.labelsDonut.push({ id: label.labelId, key: label.labelName, color: color, total: label.total });
            });
        }
        state.loadingLabels = false;
    },

    dashboardLabelErr(state, err) {
        state.loadingLabels = false;
        state.error = err;
    },

    dashboardTicktesCountBegin(state) {
        state.loading = true;
    },

    dashboardTicketsCountSuccess(state, data) {
        state.ticketsDonut = [
            {
                id: 1,
                color: "#FF4560",
                total: 0,
                key: "open",
                suffix: "",
                prefix: "",
            },
            {
                id: 2,
                color: "#775DD0",
                total: 0,
                key: "close",
                suffix: "",
                prefix: "",
            },
            {
                id: 3,
                color: "#3FA7DC",
                total: 0,
                key: "pending",
                suffix: "",
                prefix: "",
            },
        ];

        if (data.length > 0) {
            state.ticketsDonut.forEach((ticket, index) => {
                const item = data.find(t => t.currentState === ticket.key);
                if (item !== undefined) {
                    state.ticketsDonut[index].total = item.total;
                }
            });

        }

        state.loading = false;
    },

    dashboardTicketsCountErr(state, err) {
        state.loading = false;
        state.error = err;
    },
}